import React, { useState, useContext } from 'react'
import { List, ListItemButton, ListItemIcon, ListItemText, Checkbox } from '@mui/material'
import { CustomListItem } from './CustomListItemBusinessRule'
import { cleanKey, cleanPath } from 'src/helper/MapperHelper'
import { maxCharactersToString } from 'src/helper/maxCharactersToString'
import { isInCheckedBoxList, deleteItemInCheckedBoxList, isLabelInCheckedBoxList } from './helper'
import { findProps } from 'src/helper/FindProps'
import { CheckboxContext } from 'src/components/pages/sales/business-rule/logic/CheckboxContext'

export const MapperComponent = ({ data }) => {
  const [expandedKeys, setExpandedKeys] = useState([])
  const { checkedBox, setCheckedBox } = useContext(CheckboxContext)

  const isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n)
  }

  const cleanKeyIsUsed = (label) => {
    return isLabelInCheckedBoxList(checkedBox, label)
  }

  const concatPath = (listPath, last_position) => {
    if (listPath && Array.isArray(listPath)) {
      return listPath.slice(-last_position).join('_')
    }
    return null
  }

  const onClickItem = (key, value) => () => {
    if (isNumeric(value)) {
      const currentIndex = isInCheckedBoxList(checkedBox, key)
      let newChecked = [...checkedBox]
      if (!currentIndex) {
        const path = findProps(data, key)
        if (cleanKeyIsUsed(cleanKey(key))) {
          const obj = {
            key,
            value,
            label: concatPath(cleanPath(path, true).flat(), 3),
            search: cleanPath(path, true).flat(),
          }
          newChecked.push(obj)
        } else {
          const obj = {
            key,
            value,
            label: cleanKey(key),
            search: cleanPath(path, true).flat(),
          }
          newChecked.push(obj)
        }
      } else {
        newChecked = deleteItemInCheckedBoxList(checkedBox, key)
      }
      setCheckedBox(newChecked)
    }
  }

  return (
    <List
      sx={{
        bgcolor: 'background.paper',
        width: '100%',
        height: 400,
        flexGrow: 1,
        maxWidth: 'auto',
        overflow: 'auto',
      }}
    >
      {Object.entries(data).map((element) => {
        const [key, value] = element
        const key_clean = cleanKey(key)

        return typeof value !== 'object' || value == null ? (
          <ListItemButton key={key} onClick={onClickItem(key, value)} className='list_item_button'>
            <ListItemIcon>
              <Checkbox
                className='list_item_checkbox'
                edge='start'
                checked={isInCheckedBoxList(checkedBox, key)}
                tabIndex={-1}
                disableRipple
                disabled={!isNumeric(value)}
              />
            </ListItemIcon>
            <ListItemText primary={`${key_clean} : ${maxCharactersToString(value)}`} />
          </ListItemButton>
        ) : (
          /* --------recursive------- */
          <CustomListItem
            key={key}
            propKey={key}
            propValue={value}
            expandedKeys={expandedKeys}
            setExpandedKeys={setExpandedKeys}
            checkedBox={checkedBox}
            setCheckedBox={setCheckedBox}
            onClickItem={onClickItem}
            isNumeric={isNumeric}
          />
        )
      })}
    </List>
  )
}
